import React, { useEffect, useState } from 'react';
import './css/index.scss';
import { useDispatch, useSelector } from 'react-redux';
import DropdownIcon from '../../assets/formIcons/infoDropdown.svg';
import { getAdminCategoriesRequest } from '../../store/actions/categories';

function SubCategoriesTable({
  onClick, selectedSubCategory, isOnline,
}) {
  const dispatch = useDispatch();
  const { categories } = useSelector((store) => store.categories);
  const [categoriesOpen, setCategoriesOpen] = useState({});

  const handleClick = (item) => () => {
    onClick(item);
  };

  const toggleCategory = (categoryId) => () => {
    setCategoriesOpen((prev) => ({
      ...prev,
      [categoryId]: !prev[categoryId],
    }));
  };

  useEffect(() => {
    dispatch(getAdminCategoriesRequest({ is_online: isOnline, with_sub_categories: 'true' }));
    setCategoriesOpen({});
  }, [isOnline]);

  return (
    <div className="sub_categories_table">
      <div className="sub_categories_block">
        <div className="sub_categories_items_list">
          <div className="sub_categories_items_list_inner">
            {categories.map((category) => {
              const isCategoryOpen = Boolean(categoriesOpen[category._id]);
              const subCategories = category.sub_categories || [];

              return (
                <div key={category._id} className="sub_categories_category_group">
                  <div
                    className="sub_categories_category_header"
                    onClick={toggleCategory(category._id)}
                  >
                    <p className="sub_categories_category_name">{category.name}</p>
                    <img
                      className={`sub_categories_dropdown_img ${!isCategoryOpen && 'rotated'}`}
                      src={DropdownIcon}
                      alt=""
                    />
                  </div>
                  {isCategoryOpen && (
                    <div className="sub_categories_subcategories_list">
                      <div
                        key={`all_${category._id}`}
                        onClick={handleClick({ _id: `all_${category._id}`, name: '*Все*', category_id: category._id })}
                        className={`sub_categories_item ${selectedSubCategory?._id === `all_${category._id}` && 'selected'}`}
                      >
                        <p className="sub_categories_item_name">*Все*</p>
                      </div>
                      {subCategories.map((subCategory) => (
                        <div
                          key={subCategory._id}
                          onClick={handleClick(subCategory)}
                          className={`sub_categories_item ${selectedSubCategory?._id === subCategory._id && 'selected'}`}
                        >
                          <p className="sub_categories_item_name">{subCategory.name}</p>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SubCategoriesTable;
